import { render, staticRenderFns } from "./myAssign.vue?vue&type=template&id=131600ff&scoped=true"
import script from "./myAssign.vue?vue&type=script&lang=js"
export * from "./myAssign.vue?vue&type=script&lang=js"
import style0 from "./myAssign.vue?vue&type=style&index=0&id=131600ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131600ff",
  null
  
)

export default component.exports